import router from "@/router";

export const isAdminRoute = () => {
  return router.currentRoute.value.path.startsWith("/admin/");
}; 
